import React from 'react';
import styled from 'styled-components';
import { Grid, Cell } from '../grid';


const TokenInfoSectionContainer = styled.div`
  max-width: 730px;
  margin: auto;
  padding-bottom: 0px;
  padding-top: 80px;
  align: center;
  
`;

const TokenMainImage = styled.div`
margin-left:20px;
margin-top: 10px;
  img {
    height: 35px;
  }
`;

const TokenTitle = styled.div`
  
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 10px;
  letter-spacing: 0.88px;
  line-height: 28px;
  text-align: center;
  
`;

const SubTokenTitle = styled.div`
  color: #7d7d7d;
  margin: 4px 0 20px 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;
`

const ChainDesc = styled.div`
  font-size: 12.5px;
  letter-spacing: -.21px;
  line-height: 1.44;
  padding-top: 16px;
  margin: 0 auto 30px;
`
const TokenType = styled.div`
  
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.88px;
  line-height: 28px;
  
`;

const TokenAdd = styled.div`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.88px;
  line-height: 28px;
  text-align: left;
  margin-left: 30px;
`;

const TokenAddressLabel = styled.div`
  color: #000000;
  margin-top: 30px;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0.9px
  text-transform: uppercase;
`;

const LinkApp = styled.a`
  color: #2d59f8;
  text-decoration: none;
`

const TokenAddress = styled.div`
  color: #666666;
  margin-bottom: 48px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.28px;

  @media (min-width: 420px) {
    font-size: 14px;
  }
`;



const InfoItemLabel = styled.div`
  a {
    
    color: #005cb3;
    font-size: 16px;
    line-height: 22px;
    text-decoration: none;
    margin-bottom: 30px;
    
  }
`;








function TokenInfoSection({ input }) {
  return (
    <TokenInfoSectionContainer>
   
      <TokenTitle>{input.primary.token_chain.text}</TokenTitle>
      <SubTokenTitle>
        {
        input.primary.attr.text === 'native' ? (
          <>
            <span>
              TUSD launches natively on below blockchains. Mint & redeem TUSD on those networks via&nbsp;
              <LinkApp href="https://app.trusttoken.com/signup-or-signin" target='_blank' rel='noopener noreferrer'>TUSD APP</LinkApp>
            </span>
          </>
        ) : input.primary.sub_title.text
        }
      </SubTokenTitle>

      <table  frame="hsides" rules="rows" text-align="left"   width="730px"   border="2"  border-style='solid' border-color='#ff0000' >
      <tbody>
        {input.items.map((item, i) => {
          return (
            <tr key={i}>
                <td  width="80px" ><TokenMainImage><img src={item.info_icon.url} /></TokenMainImage>
                </td>
                <td width="200px"><TokenType>{item.token_type.text}</TokenType></td>
                <td width="450px">
                  {/* <TokenAdd>Address  </TokenAdd> */}
                  <InfoItemLabel>
                    <a href={item.token_link.url && item.token_link.url} target="_blank" rel="noopener noreferrer" textDecoration="none"  color="#005cb3">
                      {item.token_address.text}
                    </a>
                  </InfoItemLabel>
                </td>
            </tr>
          );
        })}
      </tbody>
      </table>
        {input.primary.attr.text === 'bridge' &&
          <ChainDesc>
              <span>*Please note that the <LinkApp href="https://app.trusttoken.com/signup-or-signin" target='_blank' rel='noopener noreferrer'>TUSD APP</LinkApp>  only supports native versions of TUSD</span>
          </ChainDesc>
        }
    </TokenInfoSectionContainer>
  );
}

export { TokenInfoSection };
